// next
import NextLink from 'next/link'
// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material'
// routes
// utils
import { fCurrency } from '@/utils/formatNumber'
// @types
import { MerchandisePreview } from '@/types/merchandise'
// components
import Label from '@/components/Label'
import Image from '@/components/Image'
import useLocales from '@/hooks/useLocales'

// ----------------------------------------------------------------------

type Props = {
  product: MerchandisePreview
}

export default function ShopProductCard({ product }: Props) {
  const { currentLang } = useLocales()
  const { title, price, slug, previewUrl, abstract, tags } = product
  const linkTo = `/${currentLang.value}/product/${slug}`

  return (
    <NextLink href={linkTo} locale={false} hrefLang={currentLang.value} passHref>
      <Card sx={{ cursor: 'pointer' }}>
        <Link
          href={linkTo}
          hrefLang={currentLang.value}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative' }}>
            {Boolean(tags.length) && (
              <Label
                variant="filled"
                color={(tags[0].name === 'sale' && 'error') || 'info'}
                sx={{
                  top: 16,
                  right: 16,
                  zIndex: 9,
                  position: 'absolute',
                  textTransform: 'uppercase',
                }}
              >
                {tags[0].name}
              </Label>
            )}
            <Image alt={title} src={previewUrl ?? ''} ratio="1/1" />
          </Box>

          <Stack spacing={2} sx={{ p: 3 }}>
            <Link color="inherit" href={linkTo} hrefLang={currentLang.value}>
              <Typography variant="subtitle2" noWrap>
                {title}
              </Typography>
            </Link>
            <Typography
              variant="caption"
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 5,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {abstract}
            </Typography>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <div />
              {/* <ColorPreview colors={colors} /> */}

              <Stack direction="row" spacing={0.5}>
                {/* {priceSale && (
              <Typography
                component="span"
                sx={{ color: 'text.disabled', textDecoration: 'line-through' }}
              >
                {fCurrency(priceSale)}
              </Typography>
            )} */}

                {price && <Typography variant="subtitle1">{fCurrency(price)}</Typography>}
              </Stack>
            </Stack>
          </Stack>
        </Link>
      </Card>
    </NextLink>
  )
}
